<template>
  <div class="vld-parent">
    
    
    <loading :active.sync="isLoading" 
    :can-cancel="true" 
    :is-full-page="fullPage"></loading>

    <div class="row">
      <div class="col-md-12 style-paper table-responsive">
        
        <table cellspacing="0" cellpadding="0" border="0" class="el-table ">
          <thead class="has-gutter">
            <tr class="text-primary"><th class="text-center" v-for="column in columns1" :key="column.id">{{column}}</th></tr>
          </thead>
          <tbody>
            <tr v-for="(project,index) in projectData"  :key="project.id">
              <td v-if="project.checked"><input type="checkbox" checked v-model="project.checked" @change="checkProject()"></td>
              <td v-if="!project.checked"><input type="checkbox" checked v-model="project.checked" @change="uncheckProject()"></td>
              <td class="text-center">{{project.name}}</td>
              <td class="text-center">{{project.hours_per_week}}</td>
              <td class="text-center">{{(project.fixed_or_hourly == 0? 'Hourly':'Fixed')}}</td>
              <td class="text-center">{{project.start_date}}</td>
              <td class="text-center">{{project.end_date}}</td>
              <td class="text-center">{{project.total_hours}}</td>
              <td class="text-center">${{project.hourly_rate}}</td>
              <td class="text-center">${{project.total_fee.toLocaleString()}}</td>
              <td class="text-center">
                <select v-model="project.status" @change="updateProject(project)">
                  <option
                      v-for="(status, index) in Object.keys(statusMap)" :key="index"
                      :value="status">
                    {{ statusMap[status] }}
                  </option>
                </select>
              </td>
              
              <td style="width: 40px; height:50px;" class="text-center">
                <button @click="deleteProject(index)" type="button" class="btn btn-icon btn-danger btn-sm">
                  <i class="fa fa-times"></i>
                </button>
              </td>
            </tr>
            <tr class="last-row">
              <td></td>
              <td>
                <div class="input-field m-2">
                  <input class="form-control plan-projects-input-style"  ref="name" placeholder="Name" v-model="input.name" id="projects" type="text">
                </div>
              </td>
              <td>
                <div class="input-field m-2">
                  <input class="form-control plan-projects-input-style text-right"   style="width: 90px;"  ref="hours_week" placeholder="Hours" v-model="input.hours_week" id="hours_week" type="number">
                </div>
              </td>
              <td>
                <div class="input-field m-2">
                  <select class="text-primary plan-projects-select" v-on:change="changeJobType($event)" v-model="input.fixed_hourly">
                    <option selected="selected" value="0">Hourly</option>
                    <option value="1">Fixed</option>
                  </select>
                </div>
              </td>

              <td>
                <div class="input-field m-2 mx-auto" style="width: 170px;">
                  <datepicker
                      :value="input.startDate"
                      class="mx-auto plan-projects-input-style"
                      v-model="input.startDate"
                      format="yyyy-MM-dd"
                      calendar-button-icon="far fa-calendar-alt"
                      :calendar-button="true">
                  </datepicker>
                </div>
              </td>

              <td>
                <div class="input-field m-2 mx-auto " style="width: 170px;">
                  <datepicker
                      :value="input.endDate"
                      class="mx-auto plan-projects-input-style"
                      v-model="input.endDate"
                      format="yyyy-MM-dd"
                      calendar-button-icon="far fa-calendar-alt"
                      :calendar-button="true">
                  </datepicker>
                </div>
              </td>

              <td>
                <div class="input-field m-2 mx-auto">
                  <input class="form-control plan-projects-input-style text-right"  style="width: 120px;"  ref="totalHours" placeholder="Total Hours" v-model="input.totalHours" id="totalHours" type="number">
                </div>
              </td>
              <td>
                <div class="input-field m-2 mx-auto">
                  <input class="form-control plan-projects-input-style text-right"  style="width: 120px;"  v-bind:disabled="isFixedRate" ref="hourlyRate" placeholder="Hourly Rate" v-model="input.hourlyRate" id="hourlyRate" type="number">
                </div>
              </td>
              <td>
                <div class="input-field m-2 mx-auto">
                  <input class="form-control plan-projects-input-style text-right"  style="width: 100px;"  v-bind:disabled="!isFixedRate"  ref="totalFee" placeholder="TotalFee" v-model="input.totalFee" id="totalFee" type="number">
                </div>
              </td>
              <td>
                <div class="input-field pr-3 m-2 mx-auto">
                  <select class="text-primary plan-projects-select" v-on:change="changeStatus($event)" v-model="input.status">
                    <option
                        v-for="(status, index) in Object.keys(statusMap)" :key="index"
                        :selected="index === 0"
                        :value="status">
                      {{ statusMap[status] }}
                    </option>
                  </select>
                </div>
              </td>
              <td  class="text-right">
                <a  @click="add" class="btn btn-success add-btn" v-bind:disabled="!validProject"><i class="fa fa-plus" style="margin-right: 5px;"/> Add Project</a>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>

  <div class="row">
    <div class="col-md-6 ">
      <div v-if="showProjections" class="style-paper text-center">

      <!-- projectionsData table -->
      <table cellspacing="0" cellpadding="0" border="0" class="el-table plan-projects-table">
        <thead class="has-gutter">
          <tr class="text-primary"><th class="text-center" v-for="column in columns2" :key="column.id">{{column}}</th></tr>
        </thead>
        <tbody>
          <tr
            v-for="(weeklyStatus, id) in weeklyStatusData"
            :key="weeklyStatus.id"
            :class="[weeklyStatusData.length === id + 1 ? 'last-row' : '']">

          <td class="text-center">{{weeklyStatus.weekof | moment("MMM D, YYYY")}}</td>
          <td class="text-center">{{weeklyStatus.hours}}</td>
          <td class="text-center">${{Math.round(weeklyStatus.earned).toLocaleString()}}</td>
          <td class="text-center">${{(weeklyStatus.effectiveRate).toFixed(2)}}</td>
          </tr>
        </tbody>
      </table>

      </div>
    </div>
    <div class="col-md-6 ">
      <div class="row">
        <div class="col-md-12 ">
          <div v-if="showProjections" class="plan-project-chart text-center remove-paddings">
            <div class="margin-left style-paper">
              <!-- <small class="text-center">Cumulative Increased Earnings Over Time</small> -->
              <line-chart :data="chartData" :dataset="{borderWidth:1}" :curve="false" :colors="['#51cbce', '#ef8157', '#6bd098','#66615b', '#cac4ae']"></line-chart>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 ">
          <div v-if="showProjections" class="plan-project-chart text-center remove-paddings">
            <div class="margin-left style-paper">
              <!-- <small class="text-center">Cumulative Increased Earnings Over Time</small> -->
              <line-chart :data="chartDataEr" :dataset="{borderWidth:1}" :curve="false" :colors="['#ef8157', '#6bd098','#66615b', '#cac4ae']"></line-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    <modal :show.sync="showModal"
           footer-classes="justify-content-center"
           type="notice">
      <h5 slot="header" class="modal-title">How Do You Use This Screen?</h5>
      <template>
        <div class="instruction">
          <div class="row">
            <div class="col-md-12">
              <strong>Enter your current and future projects</strong>
              <p class="description">Your projects drive your schedule, determine your income, and impact every
                area of your life.  Take on too much and you'll be scrambling through the chaos.  Take on too
                little and you'll be stressed about money.</p>
            </div>
          </div>
        </div>
        <div class="instruction">
          <div class="row">
            <div class="col-md-12">
              <strong>Play what-if and see the future</strong>
              <p class="description"> By entering your proposed projects in addition to what's currently active,
                you can see the effect of taking it on or not.  Just click the "Forecast" checkbox to add or remove
                the project from the forecast calculations.</p>
            </div>
          </div>
        </div>
        <div class="instruction">
          <div class="row">
            <div class="col-md-12">
              <strong>Forecasting isn't an exact science</strong>
              <p class="description">Don't worry about getting the fields exactly right - you may not know the exact
                Start Date, End Date, or even hours per week.  Put in your best estimate and we'll take it from there.
              </p>
            </div>
          </div>
        </div>
      </template>
      <div slot="footer" class="justify-content-center">
        <p-button type="info" round @click.native="showModal = false">Got it!</p-button>
      </div>
    </modal>
</div>

</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import { Auth, Analytics } from "aws-amplify";
import { mapActions } from 'vuex';
Vue.use(require("vue-moment"));
import {
  getProjectsAPI,
  addProjectsAPI,
  updateProjectsAPI,
  deleteProjectsAPI
} from "./../../api/api";
import Loading from "vue-loading-overlay";
import Datepicker from "vuejs-datepicker";
import VueChartkick from "vue-chartkick";
import Chart from "chart.js";
import Vue from "vue";
Vue.use(VueChartkick, { adapter: Chart });
import "vue-loading-overlay/dist/vue-loading.css";
import {moment} from "fullcalendar";
import Modal from "../UIComponents/Modal";

const statusMap = {
  0: 'Proposed',
  1: 'Active',
  2: 'Lost'
};

export default {
  components: {
    Loading,
    Datepicker,
    Modal
  },

  async beforeCreate() {
    Auth.currentSession().then();

    try {
      this.account = await Auth.currentAuthenticatedUser();
      this.signedIn = true;
    } catch (err) {
      this.signedIn = false;
    }
    AmplifyEventBus.$on("authState", async info => {
      if (info === "signedIn") {
        this.signedIn = true;
        this.account = await Auth.currentAuthenticatedUser();
      } else {
        this.signedIn = false;
      }
    });
  },

  created() {
    this.setNavbarTitle('Projects');
  },

  mounted() {
    this.getProjects();
  },
  computed: {
    showProjections() {
      return (this.projectData.length > 0) && this.projectionsAreNonZero;
    },
    fixed_hourly() {
      return this.input.fixed_hourly
    },
    hoursPerWeek() {
      return this.input.hours_week;
    },
    hourlyRate() {
      return this.input.hourlyRate;
    },
    totalHours() {
      return this.input.totalHours;
    },
    totalFee() {
      return this.input.totalFee;
    },
    startDate() {
      return this.input.startDate;
    },
    endDate() {
      return this.input.endDate;
    },
    validProject() {
      return (this.input.name != "") && (this.hoursPerWeek > 0) && (this.startDate != "") && (this.endDate != "") && (this.totalHours > 0) && (this.hourlyRate > 0) && (this.totalFee > 0)
    }
  },

  watch: {
    hourlyRate() {
      this.updateTotalFee();
    },
    totalHours() {
      this.updateTotalFee();
      this.updateHourlyRate();
    },
    totalFee() {
      this.updateHourlyRate();
    },
    hoursPerWeek() {
      this.updateTotalHours();
    },
    startDate() {
      this.updateTotalHours();
    },
    endDate() {
      this.updateTotalHours();
    },
    fixed_hourly(newValue) {
      this.isFixedRate = newValue == 1;
    }
  },

  data() {
    return {
      statusMap,
      showModal:false,
      isLoading: false,
      isFixedRate: false,
      fullPage: true,
      projectData: {},
      projectionsData: {},
      yearCols: {},
      columns1: [
        "Forecast",
        "Name",
        "Hours / Week",
        "Fixed / Hourly",
        "Start Date",
        "End Date",
        "Total Hours",
        "Hourly Rate",
        "Total Fee",
        "Status",
        ""
      ],
      columns2: ["Week Of", "Hours", "Earned", "Effective Rate"],

      weekTotalHours: 0,
      weekTotalEarned: 0,

      input: {
        name: "",
        hours_week: "",
        fixed_hourly: 0,
        startDate: "",
        endDate: "",
        totalHours:"",
        hourlyRate:"",
        totalFee:"",
        status: 0
      },
      editInput: {
        name: "",
        hours_week: "",
        fixed_hourly: 0,
        startDate: "",
        endDate: "",
        totalHours: "",
        hourlyRate: "",
        totalFee: "",
        status: 0
      },
      chartData: [],
      chartDataEr: [],
      weeklyStatusData: [],
      projectionsAreNonZero: true
    };
  },

  methods: {
    ...mapActions('UI', ['setNavbarTitle']),

    updateTotalFee() {
      if (!this.isFixedRate) {
        let total_hours = 0;
        let hourly_rate = 0;
        if (parseFloat(this.input.totalHours) > 0) {
          total_hours = parseFloat(this.input.totalHours);
        }
        if (parseFloat(this.input.hourlyRate) > 0) {
          hourly_rate = parseFloat(this.input.hourlyRate);
        }
        this.input.totalFee = (total_hours * hourly_rate).toFixed(0);
      }
    },

    updateHourlyRate() {
      if (this.isFixedRate) {
        let total_hours = 0;
        let total_fee = 0;
        if (parseFloat(this.input.totalHours) > 0) {
          total_hours = parseFloat(this.input.totalHours);
        }
        if (parseFloat(this.input.totalFee) > 0) {
          total_fee = parseFloat(this.input.totalFee);
        }
        if (total_hours > 0) {
          this.input.hourlyRate = (total_fee / total_hours).toFixed(2);
        } else {
          this.input.hourlyRate = "";
        }
      }
    },

    updateTotalHours() {
      let hours_per_week = 0;
      if (parseFloat(this.input.hours_week) > 0) {
        hours_per_week = parseFloat(this.input.hours_week);
      }

      if (this.input.startDate == "" || this.input.endDate == "") {
        this.input.totalHours = hours_per_week;
      } else {
        const startDate = new Date(this.input.startDate);
        const endDate = new Date(this.input.endDate);
        const working_days = this.getNumberOfWorkingDays(startDate, endDate);
        const total_hours = hours_per_week / 5 * working_days;
        this.input.totalHours = total_hours.toFixed(0);
      }
    },
    getNumberOfWorkingDays(startDate, endDate) {
      var day = moment(startDate);
      var businessDays = 0;

      while (day.isSameOrBefore(endDate,'day')) {
        if (day.day()!=0 && day.day()!=6) businessDays++;
        day.add(1,'d');
      }
      return businessDays;
    },

    changeJobType: function (event) {
      this.input.fixed_hourly = event.target.value;
    },
    changeStatus: function(event) {
      this.input.status = event.target.value;
    },
    getProjects() {
      this.isLoading = true;
      getProjectsAPI().then(data => {
        this.projectData = data;
        this.projectData.forEach(function(project, index) {
          if (project.status == 1) {
            project.checked = true;
          } else {
            project.checked = false;
          }

        });
        if (this.projectData.length == 0) {
          this.showModal = true;
        }
        this.isLoading = false;
        this.getWeeklyReport();
      });
    },
    addProjects(params) {
      params.fixed_or_hourly = parseInt(params.fixed_or_hourly);
      addProjectsAPI(params).then(data => {
        if (data != null && data != "") {
          this.projectData.push(data);
          this.getWeeklyReport();
        }
      });
    },

    updateProject(project) {
      project.status = parseInt(project.status)
      if (project.status == 2) {
        project.checked = false;
      }
      if (project.status == 1) {
        project.checked = true;
      }
      updateProjectsAPI(project).then(() => {
        this.getWeeklyReport();
      });
    },

    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    validate() {
      this.$validator.validateAll().then(isValid => {
        this.$emit("on-submit", this.registerForm, isValid);
      });
    },

    add: function() {
      let params = {}

      params.name = this.input.name
      
      params.hours_per_week = parseFloat(this.input.hours_week)
      params.total_hours = parseFloat(this.input.totalHours)
      params.start_date = this.input.startDate
      params.end_date = this.input.endDate
      params.fixed_or_hourly = this.input.fixed_hourly
      params.hourly_rate = parseFloat(this.input.hourlyRate)
      params.total_fee = parseFloat(this.input.totalFee)
      params.status = parseInt(this.input.status)
      
      this.addProjects(params)


      this.input.name = "";
      this.input.hours_week = "";
      this.input.startDate = "";
      this.input.endDate = "";
      this.input.hourlyRate = "";
      this.input.totalHours= "";
      this.input.totalFee = ""
      this.$refs.name.focus();
      Analytics.record({ name: "plan projects add project" });
    },
    deleteProject: function(index) {
      let project = this.projectData[index];
      deleteProjectsAPI(project.entity_id).then();
      this.projectData.splice(index, 1);
      this.getWeeklyReport();
      Analytics.record({ name: "plan projects delete project" });
    },

    checkProject: function() {
      this.getWeeklyReport();
      Analytics.record({ name: "plan projects enable forecast" });
    },
    uncheckProject: function() {
      this.getWeeklyReport();
      Analytics.record({ name: "plan projects disable forecast" });
    },

    /////////-------------- calculate modules -----------------

    getWeeklyReport() {
      let firstMonday = this.getMonday(this.getEarlistDateFromProjects());
      let lastMonday = this.getMonday(this.getLastDateFromProjects());
      let nextMonday = firstMonday;

      //add chart data
      this.chartData = [];
      this.chartDataEr = [];
      this.weeklyStatusData = [];

      let chartEarnedItem = {};
      chartEarnedItem.name = "Earned";
      chartEarnedItem.data = {};

      let chartEffectiveRateitem = {};
      chartEffectiveRateitem.name = "Effective Rate";
      chartEffectiveRateitem.data = {};

      var i = 0;
      while (1) {
        i++;
        nextMonday = this.getNextMonday(nextMonday);

        this.gethoursEarnedPerWeek(nextMonday);

        chartEarnedItem.data[
          this.getFormatDate(nextMonday)
        ] = this.weekTotalEarned.toFixed(0);

        let effectiveRate = this.weekTotalEarned / this.weekTotalHours;
        if (!(effectiveRate > 0)) {
          effectiveRate = 0;
        }

        chartEffectiveRateitem.data[this.getFormatDate(nextMonday)] = effectiveRate.toFixed(2);

        this.weeklyStatusData.push({
          weekof: nextMonday,
          hours: this.weekTotalHours,
          earned: this.weekTotalEarned,
          effectiveRate: effectiveRate
        });

        if (nextMonday >= lastMonday) {
          break;
        }
      }

      this.chartData.push(chartEarnedItem);
      this.chartDataEr.push(chartEffectiveRateitem);
    },

    gethoursEarnedPerWeek(d) {
      this.weekTotalHours = 0;
      this.weekTotalEarned = 0;
      let showProjections = false;
      if (this.projectData.length > 0) {
        let _weekself = this;
        this.projectData.forEach(function(project, index) {
          if (project.checked) {
            showProjections = true;
            if (
              d >= new Date(project.start_date) &&
              d <= new Date(project.end_date)
            ) {
              if (project.fixed_hourly == 0) {
                //hourly
                _weekself.weekTotalHours += project.hours_per_week;
                _weekself.weekTotalEarned +=
                  project.hourly_rate * project.hours_per_week;
              } //fixed
              else {
                let hourlyRate = project.total_fee / project.total_hours;
                if (!(hourlyRate > 0)) {
                  hourlyRate = 0;
                }
                _weekself.weekTotalHours += project.hours_per_week;
                _weekself.weekTotalEarned +=
                  hourlyRate * project.hours_per_week;
              }
            }
          }
        });
      }

      this.projectionsAreNonZero = showProjections;
    },

    getMonday(d) {
      d = new Date(d);
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
      return new Date(d.setDate(diff));
    },

    getNextMonday(d) {
      d = new Date(d);
      d.setDate(d.getDate() + ((7 - d.getDay()) % 7) + 1);
      return d;
    },

    getFormatDate(d) {
      var today = d;
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!

      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      var today = mm + "/" + dd + "/" + yyyy;
      return today;
    },
    getEarlistDateFromProjects() {
      var earlistDate = new Date(2200, 1, 1);

      if (this.projectData.length > 0) {
        this.projectData.forEach(function(project, index) {
          if (earlistDate > new Date(project.start_date)) {
            earlistDate = new Date(project.start_date);
          }
        });
      }
      return earlistDate;
    },

    getLastDateFromProjects() {
      var lastDate = new Date(1980, 1, 1);

      if (this.projectData.length > 0) {
        this.projectData.forEach(function(project, index) {
          if (lastDate < new Date(project.end_date)) {
            lastDate = new Date(project.end_date);
          }
        });
      }
      return lastDate;
    }
  }
};
</script>

<style scoped>
  .vdp-datepicker input {
    margin: 0 auto;
  }
  @media (max-width: 991px) {
    .remove-paddings {
      padding-left: 0;
      padding-right: 0;
    }
  }
  @media (min-width: 992px) {
    .remove-paddings {
      padding-right: 0;
    }
    /* .margin-left {
      margin-left: 30px;
    } */
  }
</style>
<style>
  .el-table--group::after, .el-table--border::after, .el-table::before {
    background-color: transparent !important; 
  }
  .plan-projects-select {
    background-color: white;
    padding: 5px;
    border: 1px solid #51cbce;
    border-radius: 3px;
  }
  .plan-projects-input-style {
    width: 80%;
    display: block;
    margin: 0 auto;
  }
  .vdp-datepicker input {
    width: 80%;
    display: block;
    padding:5px;
    background-color: #FFFFFF;
    border: 1px solid #DDDDDD;
    border-radius: 4px;
    color: #66615b;
    line-height: normal;
    font-size: 14px;
    -webkit-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
    -moz-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
    -o-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
    -ms-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
    transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .plan-project-chart {
    height: 100%;
  }
  .vdp-datepicker__calendar {
    position: fixed;
  }
</style>
